import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=bc198532"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=bc198532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports